module.exports = __webpack_public_path__ + "static/img/zhongzhongka13.5795ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka13.png
// module id = +xU/
// module chunks = 16